export default {
  sv: require('../icons/flags/sv.png'),
  ad: require('../icons/flags/ad.png'),
  cm: require('../icons/flags/cm.png'),
  ga: require('../icons/flags/ga.png'),
  gh: require('../icons/flags/gh.png'),
  gw: require('../icons/flags/gw.png'),
  mv: require('../icons/flags/mv.png'),
  mw: require('../icons/flags/mw.png'),
  ne: require('../icons/flags/ne.png'),
  sz: require('../icons/flags/sz.png'),
  ki: require('../icons/flags/ki.png'),
  kz: require('../icons/flags/kz.png'),
  uz: require('../icons/flags/uz.png'),
  sg: require('../icons/flags/sg.png'),
  th: require('../icons/flags/th.png'),
  mq: require('../icons/flags/mq.png'),
  bw: require('../icons/flags/bw.png'),
  ke: require('../icons/flags/ke.png'),
  sc: require('../icons/flags/sc.png'),
  sd: require('../icons/flags/sd.png'),
  sn: require('../icons/flags/sn.png'),
  bn: require('../icons/flags/bn.png'),
  ru: require('../icons/flags/ru.png'),
  by: require('../icons/flags/by.png'),
  cy: require('../icons/flags/cy.png'),
  cyp: require('../icons/flags/cyp.png'),
  ee: require('../icons/flags/ee.png'),
  es: require('../icons/flags/es.png'),
  is: require('../icons/flags/is.png'),
  li: require('../icons/flags/li.png'),
  no: require('../icons/flags/no.png'),
  si: require('../icons/flags/si.png'),
  sk: require('../icons/flags/sk.png'),
  ua: require('../icons/flags/ua.png'),
  gu: require('../icons/flags/gu.png'),
  ba: require('../icons/flags/ba.png'),
  aw: require('../icons/flags/aw.png'),
  bj: require('../icons/flags/bj.png'),
  bl: require('../icons/flags/bl.png'),
  bm: require('../icons/flags/bm.png'),
  bq: require('../icons/flags/bq.png'),
  bs: require('../icons/flags/bs.png'),
  cv: require('../icons/flags/cv.png'),
  cw: require('../icons/flags/cw.png'),
  fj: require('../icons/flags/fj.png'),
  fo: require('../icons/flags/fo.png'),
  gn: require('../icons/flags/gn.png'),
  gy: require('../icons/flags/gy.png'),
  ht: require('../icons/flags/ht.png'),
  ic: require('../icons/flags/ic.png'),
  ir: require('../icons/flags/ir.png'),
  ls: require('../icons/flags/ls.png'),
  mf: require('../icons/flags/mf.png'),
  mr: require('../icons/flags/mr.png'),
  na: require('../icons/flags/na.png'),
  nr: require('../icons/flags/nr.png'),
  pg: require('../icons/flags/pg.png'),
  ps: require('../icons/flags/ps.png'),
  rw: require('../icons/flags/rw.png'),
  sr: require('../icons/flags/sr.png'),
  tg: require('../icons/flags/tg.png'),
  to: require('../icons/flags/to.png'),
  tt: require('../icons/flags/tt.png'),
  hi: require('../icons/flags/hi.png'),
  va: require('../icons/flags/va.png'),
  vi: require('../icons/flags/vi.png'),
  vu: require('../icons/flags/vu.png'),
  yt: require('../icons/flags/yt.png'),
  tj: require('../icons/flags/tj.png'),
  mn: require('../icons/flags/mn.png'),
  np: require('../icons/flags/np.png'),
  mz: require('../icons/flags/mz.png'),
  et: require('../icons/flags/et.png'),
  cu: require('../icons/flags/cu.png'),
  iq: require('../icons/flags/iq.png'),
  ag: require('../icons/flags/ag.png'),
  ai: require('../icons/flags/ai.png'),
  an: require('../icons/flags/an.png'),
  bb: require('../icons/flags/bb.png'),
  br: require('../icons/flags/br.png'),
  dm: require('../icons/flags/dm.png'),
  do: require('../icons/flags/do.png'),
  be: require('../icons/flags/be.png'),
  bg: require('../icons/flags/bg.png'),
  gd: require('../icons/flags/gd.png'),
  gf: require('../icons/flags/gf.png'),
  gp: require('../icons/flags/gp.png'),
  jm: require('../icons/flags/jm.png'),
  kn: require('../icons/flags/kn.png'),
  ky: require('../icons/flags/ky.png'),
  lc: require('../icons/flags/lc.png'),
  ms: require('../icons/flags/ms.png'),
  tc: require('../icons/flags/tc.png'),
  vc: require('../icons/flags/vc.png'),
  vg: require('../icons/flags/vg.png'),
  ax: require('../icons/flags/ax.png'),
  mu: require('../icons/flags/mu.png'),
  dz: require('../icons/flags/dz.png'),
  ge: require('../icons/flags/ge.png'),
  gl: require('../icons/flags/gl.png'),
  la: require('../icons/flags/la.png'),
  cf: require('../icons/flags/cf.png'),
  ye: require('../icons/flags/ye.png'),
  sa: require('../icons/flags/sa.png'),
  rs: require('../icons/flags/rs.png'),
  ie: require('../icons/flags/ie.png'),
  it: require('../icons/flags/it.png'),
  lt: require('../icons/flags/lt.png'),
  lu: require('../icons/flags/lu.png'),
  lv: require('../icons/flags/lv.png'),
  mt: require('../icons/flags/mt.png'),
  nl: require('../icons/flags/nl.png'),
  pt: require('../icons/flags/pt.png'),
  ro: require('../icons/flags/ro.png'),
  im: require('../icons/flags/im.png'),
  je: require('../icons/flags/je.png'),
  mc: require('../icons/flags/mc.png'),
  md: require('../icons/flags/md.png'),
  at: require('../icons/flags/at.png'),
  ar: require('../icons/flags/ar.png'),
  bo: require('../icons/flags/bo.png'),
  jp: require('../icons/flags/jp.png'),
  kr: require('../icons/flags/kr.png'),
  ws: require('../icons/flags/ws.png'),
  xk: require('../icons/flags/xk.png'),
  fi: require('../icons/flags/fi.png'),
  fr: require('../icons/flags/fr.png'),
  hk: require('../icons/flags/hk.png'),
  qa: require('../icons/flags/qa.png'),
  tr: require('../icons/flags/tr.png'),
  cd: require('../icons/flags/cd.png'),
  cg: require('../icons/flags/cg.png'),
  ci: require('../icons/flags/ci.png'),
  re: require('../icons/flags/re.png'),
  za: require('../icons/flags/za.png'),
  ph: require('../icons/flags/ph.png'),
  kg: require('../icons/flags/kg.png'),
  mo: require('../icons/flags/mo.png'),
  py: require('../icons/flags/py.png'),
  my: require('../icons/flags/my.png'),
  id: require('../icons/flags/id.png'),
  ae: require('../icons/flags/ae.png'),
  in: require('../icons/flags/in.png'),
  il: require('../icons/flags/il.png'),
  am: require('../icons/flags/am.png'),
  az: require('../icons/flags/az.png'),
  bh: require('../icons/flags/bh.png'),
  jo: require('../icons/flags/jo.png'),
  lk: require('../icons/flags/lk.png'),
  mk: require('../icons/flags/mk.png'),
  us: require('../icons/flags/us.png'),
  se: require('../icons/flags/se.png'),
  mx: require('../icons/flags/mx.png'),
  kh: require('../icons/flags/kh.png'),
  vn: require('../icons/flags/vn.png'),
  cl: require('../icons/flags/cl.png'),
  cr: require('../icons/flags/cr.png'),
  hn: require('../icons/flags/hn.png'),
  pk: require('../icons/flags/pk.png'),
  al: require('../icons/flags/al.png'),
  ca: require('../icons/flags/ca.png'),
  nz: require('../icons/flags/nz.png'),
  co: require('../icons/flags/co.png'),
  bf: require('../icons/flags/bf.png'),
  gi: require('../icons/flags/gi.png'),
  ch: require('../icons/flags/ch.png'),
  cz: require('../icons/flags/cz.png'),
  de: require('../icons/flags/de.png'),
  gr: require('../icons/flags/gr.png'),
  hu: require('../icons/flags/hu.png'),
  pl: require('../icons/flags/pl.png'),
  gg: require('../icons/flags/gg.png'),
  bd: require('../icons/flags/bd.png'),
  ec: require('../icons/flags/ec.png'),
  gt: require('../icons/flags/gt.png'),
  ni: require('../icons/flags/ni.png'),
  pa: require('../icons/flags/pa.png'),
  eg: require('../icons/flags/eg.png'),
  ng: require('../icons/flags/ng.png'),
  td: require('../icons/flags/td.png'),
  tn: require('../icons/flags/tn.png'),
  tz: require('../icons/flags/tz.png'),
  ug: require('../icons/flags/ug.png'),
  zm: require('../icons/flags/zm.png'),
  kw: require('../icons/flags/kw.png'),
  pe: require('../icons/flags/pe.png'),
  uy: require('../icons/flags/uy.png'),
  om: require('../icons/flags/om.png'),
  me: require('../icons/flags/me.png'),
  lr: require('../icons/flags/lr.png'),
  ma: require('../icons/flags/ma.png'),
  mg: require('../icons/flags/mg.png'),
  ml: require('../icons/flags/ml.png'),
  tw: require('../icons/flags/tw.png'),
  pr: require('../icons/flags/pr.png'),
  cn: require('../icons/flags/cn.png'),
  au: require('../icons/flags/au.png'),
  dk: require('../icons/flags/dk.png'),
  gb: require('../icons/flags/gb.png'),
  hr: require('../icons/flags/hr.png'),
  km: require('../icons/flags/km.png'),
  sm: require('../icons/flags/sm.png'),
  sb: require('../icons/flags/sb.png'),
  ao: require('../icons/flags/ao.png'),
  bt: require('../icons/flags/bt.png'),
  pf: require('../icons/flags/pf.png'),
  nc: require('../icons/flags/nc.png'),
  af: require('../icons/flags/af.png'),
  mm: require('../icons/flags/mm.png'),
  zw: require('../icons/flags/zw.png'),
  sx: require('../icons/flags/sx.png'),
  bz: require('../icons/flags/bz.png'),
  ss: require('../icons/flags/ss.png'),
  gm: require('../icons/flags/gm.png'),
  sl: require('../icons/flags/sl.png'),
  bi: require('../icons/flags/bi.png'),
  // fallback
  generic: require('../icons/flags/world.png'),
};
